import { useMemo } from 'react';
import cn from 'classnames';
import styles from '../MillionsIcon.module.scss';

type DollarSignGoldIconProps = React.ComponentPropsWithoutRef<'svg'> & {
  className?: string;
  size?: number;
};

let dollarSignGoldGradientIdCounter = 0;

const DollarSignGoldIcon = ({
  className,
  size = 24,
  ...rest
}: DollarSignGoldIconProps) => {
  const gradientId = useMemo(() => {
    dollarSignGoldGradientIdCounter += 1;
    return `dollar-sign-gold-gradient-${dollarSignGoldGradientIdCounter}`;
  }, []);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(styles.root, className)}
      data-icon-name="dollarSignGold"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      {...rest}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="6"
          y1="12"
          x2="18"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D09A31" />
          <stop offset="0.524038" stopColor="#FAE575" />
          <stop offset="1" stopColor="#D8A445" />
        </linearGradient>
      </defs>
      <path
        d="M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12H10C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4H14C16.2091 4 18 5.79086 18 8M12 2V22"
        stroke={`url(#${gradientId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DollarSignGoldIcon;
